import * as Utils from '../utils/utils';

const offCanvasMenu = document.querySelector('.js-offcanvas-wrapper.menu');
const offCanvasSearch = document.querySelector('.js-offcanvas-wrapper.search');
const overlay = document.querySelector('.js-overlay');
const searchInput = document.querySelector('.js-search-suggest');
const searchDelete = document.querySelector('.js-delete-search-query');
const noScrollClass = 'noscroll';

function close(el) {
  if (Utils.hasClass(el, 'open')) {
    Utils.removeClass(el, 'open');
    Utils.removeClass(overlay, 'active');
    Utils.removeClass(document.body, noScrollClass);
    Utils.removeClass(document.documentElement, noScrollClass);
    Utils.removeClass(document.querySelector('body'), 'overlay-open');
  }
}

function open(el) {
  Utils.addClass(el, 'open');
  Utils.addClass(overlay, 'active');
  Utils.addClass(document.body, noScrollClass);
  Utils.addClass(document.documentElement, noScrollClass);
  Utils.addClass(document.querySelector('body'), 'overlay-open');
}

/**
 * Defines click events on header elements
 * =======================================
*/
function OffCanvas() {
  // Close the off-canvas if we click outside
  document.querySelector('.js-overlay').addEventListener('click', () => {
    if (Utils.hasClass(overlay, 'active')) {
      close(offCanvasMenu);
      close(offCanvasSearch);
    }
  });

  // Close our menu and overlay when the `Escape` key is pressed
  document.onkeydown = (evt) => {
    const key = evt || window.event;

    if (key.keyCode === 27 && Utils.hasClass(overlay, 'active')) {
      close(offCanvasMenu);
      close(offCanvasSearch);
    }
  };

  // Main menu off-canvas element
  if (offCanvasMenu) {
    document.querySelector('#close-canvas').addEventListener('click', (el) => {
      el.preventDefault();
      close(offCanvasMenu);
    });
  }

  // Search off-canvas element
  if (offCanvasSearch) {
    document.querySelector('#close-canvas-search').addEventListener('click', (el) => {
      el.preventDefault();
      close(offCanvasSearch);
    });
  }

  // Main menu icon
  if (document.querySelector('#trigger-menu')) {
    document.querySelector('#trigger-menu').addEventListener('click', (el) => {
      el.preventDefault();
      open(offCanvasMenu);
    });
  }

  // Search menu icon
  if (document.querySelector('#trigger-search')) {
    document.querySelector('#trigger-search').addEventListener('click', (el) => {
      el.preventDefault();
      open(offCanvasSearch);
      searchInput.focus();
    });
  }

  // Search button opening block
  if (document.querySelector('#trigger-search-menu')) {
    document.querySelector('#trigger-search-menu').addEventListener('click', (e) => {
      e.preventDefault();
      open(offCanvasSearch);
      searchInput.focus();
    });
  }

  if (searchDelete) {
    searchDelete.addEventListener('click', (el) => {
      el.preventDefault();
      const input = searchDelete.closest('.input-search-menu').querySelector('.js-search-query');
      input.value = '';
      input.focus();
    });
  }
}

export default OffCanvas;
